module.exports = "<footer id=\"footer\">\n    Copyright &copy; 2018 Kiniela\n  \n    <ul class=\"f-menu\">\n      <li>\n        <a href=\"/\">Home</a>\n      </li>\n      <li>\n        <a href=\"/dashboard\">Dashboard</a>\n      </li>\n      <li>\n        <a href=\"\">Reports</a>\n      </li>\n      <li>\n        <a href=\"\">Support</a>\n      </li>\n      <li>\n        <a href=\"\">Contact</a>\n      </li>\n    </ul>\n  </footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/footer/footer.component.html
// module id = ./src/app/common/footer/footer.component.html
// module chunks = main